/**
 * Precios multimoneda POSKN (USD/Bs).
 */

export function posknResolvePreciosItem(source) {
	const tasa = window.TASA_DOLAR || 1;
	if (!source || typeof source !== 'object') {
		const usd = parseFloat(source) || 0;
		return { anchor: 'usd', usd, bs: usd * tasa, price_bs_fixed: 0, wc_usd: usd };
	}
	const anchor = String(source.price_anchor || 'usd').toLowerCase();
	const bsFixed = parseFloat(source.price_bs_fixed || 0) || 0;
	const wcUsd = parseFloat(source.price_wc_usd != null ? source.price_wc_usd : source.price) || 0;
	let usd;
	let bs;
	if (anchor === 'bs' && window.POSKN_MULTIMONEDA && bsFixed > 0) {
		bs = bsFixed;
		usd = bs / tasa;
	} else {
		usd = parseFloat(source.price_usd != null ? source.price_usd : source.price) || wcUsd;
		bs = parseFloat(source.price_bs != null ? source.price_bs : usd * tasa) || usd * tasa;
	}
	return { anchor, usd, bs, price_bs_fixed: bsFixed, wc_usd: wcUsd };
}

export function posknPrecioUnitarioCarrito(item) {
	const tasa = window.TASA_DOLAR || 1;
	const anchor = String(item.priceAnchor || 'usd').toLowerCase();
	const bsFixed = parseFloat(item.priceBsFixed || 0) || 0;
	if (anchor === 'bs' && window.POSKN_MULTIMONEDA && bsFixed > 0) {
		return { usd: bsFixed / tasa, bs: bsFixed };
	}
	const usd = parseFloat(item.price) || 0;
	return { usd, bs: usd * tasa };
}

export function posknActualizarPreciosEnPantalla($) {
	if (!window.POSKN_MULTIMONEDA) return;
	$('.producto-card').each(function () {
		const $card = $(this);
		const resolved = posknResolvePreciosItem({
			price_anchor: $card.data('price-anchor') || 'usd',
			price_bs_fixed: $card.data('price-bs-fixed') || 0,
			price_wc_usd: $card.data('price-wc-usd') || 0,
			price: $card.data('price-wc-usd') || 0,
		});
		const extra = parseFloat($card.attr('data-ckn-desde-usd') || 0) || 0;
		const usd = resolved.usd + extra;
		const bs = resolved.bs + extra * (window.TASA_DOLAR || 1);
		const prefix = extra > 0.0001 ? 'Desde ' : '';
		$card.find('.producto-price-usd').text(`${prefix}$${usd.toFixed(2)}`);
		$card.find('.producto-price-bs').text(`${prefix}Bs. ${bs.toFixed(2)}`);
	});
	if (typeof window.carrito !== 'undefined' && window.carrito.length && typeof window.actualizarCarrito === 'function') {
		window.actualizarCarrito();
	}
	if ($('#modal-pago').is(':visible') && typeof window.sincronizarTotalesModalPagoDesdeCarrito === 'function') {
		window.sincronizarTotalesModalPagoDesdeCarrito();
		$('.payment-method.selected').each(function () {
			if (typeof window.autoRellenarMetodoPago === 'function') window.autoRellenarMetodoPago($(this));
		});
		if (typeof window.actualizarResumenPago === 'function') window.actualizarResumenPago();
	}
}

export function posknTextoPrecioDual(usd, modo) {
	const n = parseFloat(usd) || 0;
	const tasa = window.TASA_DOLAR || 1;
	const bs = n * tasa;
	const extra = modo === 'extra';
	const desde = modo === 'desde';
	const pref = extra ? '+' : desde ? 'Desde ' : '';
	const usdTxt = `${pref}$${n.toFixed(2)}`;
	if (!window.POSKN_MULTIMONEDA) {
		return extra ? ` (${usdTxt})` : `${usdTxt}${desde ? '' : ' USD'}`;
	}
	const bsTxt = `${pref}Bs. ${bs.toFixed(2)}`;
	if (extra) {
		return ` (${usdTxt} / ${bsTxt})`;
	}
	return `${usdTxt} USD · ${bsTxt}`;
}

export function posknHtmlPreciosModal(precioUsdOrProduct, opts) {
	const resolved =
		typeof precioUsdOrProduct === 'object' && precioUsdOrProduct !== null
			? posknResolvePreciosItem(precioUsdOrProduct)
			: posknResolvePreciosItem({ price: precioUsdOrProduct, price_anchor: 'usd' });
	const extra = parseFloat(opts && opts.desdeExtraUsd) || 0;
	const tasa = window.TASA_DOLAR || 1;
	const usd = resolved.usd + extra;
	const bs = resolved.bs + extra * tasa;
	const u = usd.toFixed(2);
	const prefix = extra > 0.0001 ? 'Desde ' : '';
	if (!window.POSKN_MULTIMONEDA) {
		return `<div class="precio-usd">${prefix}$${u}</div>`;
	}
	const badge = resolved.anchor === 'bs' ? ' <small style="color:#2e7d32;">(Bs fijo)</small>' : '';
	return `<div class="precio-usd">${prefix}$${u} USD</div><div class="precio-bs">${prefix}Bs. ${bs.toFixed(2)}${badge}</div>`;
}

export function attachPricingGlobals(win, $) {
	win.posknResolvePreciosItem = posknResolvePreciosItem;
	win.posknPrecioUnitarioCarrito = posknPrecioUnitarioCarrito;
	win.posknActualizarPreciosEnPantalla = () => posknActualizarPreciosEnPantalla($);
	win.posknHtmlPreciosModal = posknHtmlPreciosModal;
	win.posknTextoPrecioDual = posknTextoPrecioDual;
}
